export default __webpack_public_path__ + "static/media/notification-sound.dd7912d5.mp3";